import { render } from "./AppVersionListPage.vue?vue&type=template&id=3225078f&ts=true"
import script from "./AppVersionListPage.vue?vue&type=script&lang=ts"
export * from "./AppVersionListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__